import { RouterModule, Routes } from '@angular/router';


import { RegisterComponent } from './register/register.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { LockScreenComponent } from './lockscreen/lockscreen.component';
import { SubscribesComponent } from './subscribes/subscribes.component';
import { UnderMaintanceComponent } from './under-maintance/under-maintance.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ComingsoonV2Component } from './coming-soonV2/coming-soonV2.component';
import { MaintenanceV2Component } from './maintenanceV2/maintenanceV2.component';
import { LoginoneComponent } from './loginone/loginone.component';
import { AboutComponent } from './about/about.component';
import { TherapiesComponent } from './therapies/therapies.component';
import { TariffComponent } from './tariff/tariff.component';
import { HomeComponent } from './home/home.component';
import { BookingComponent } from './booking/booking.component';
import { ContactusComponent } from './contactus/contactus.component';
import { GalleryComponent } from './gallery/gallery.component';
import { DincharyaComponent } from './dincharya/dincharya.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { BookingLoginComponent } from './booking-login/booking-login.component';
import { DonateComponent } from './donate/donate.component';
import { NgModule } from '@angular/core';
import { FacilitiesComponent } from './facilities/facilities.component';
import { OnlineyogaComponent } from './onlineyoga/onlineyoga.component';



const SessionRoutes: Routes = [{
  path: '', component: HomeComponent
}, {
  path: '',
  children: [
    {
      path: 'coming-soon', pathMatch: 'full',
      component: ComingSoonComponent
    }, {
      path: 'login', pathMatch: 'full',
      component: LoginoneComponent
    }, {
      path: 'register', pathMatch: 'full',
      component: RegisterComponent
    }, {
      path: 'forgot-password', pathMatch: 'full',
      component: ForgotPasswordComponent
    }, {
      path: 'coming-soonV2', pathMatch: 'full',
      component: ComingsoonV2Component
    }, {
      path: 'lockscreen', pathMatch: 'full',
      component: LockScreenComponent
    }, {
      path: 'not-found', pathMatch: 'full',
      component: NotFoundComponent
    }, {
      path: 'subscribes', pathMatch: 'full',
      component: SubscribesComponent
    }, {
      path: 'undermaintance', pathMatch: 'full',
      component: UnderMaintanceComponent
    }, {
      path: 'maintanceV2', pathMatch: 'full',
      component: MaintenanceV2Component
    },
    {
      path: 'about',
      component: AboutComponent,
      children: [
        { path: 'history', component: AboutComponent, data: { section: 'History' } },
        { path: 'objectofthetrust', component: AboutComponent, data: { section: 'Objectofthetrust' } },
        { path: 'trustees', component: AboutComponent, data: { section: 'Trustees' } },
        { path: 'doctors', component: AboutComponent, data: { section: 'Doctors' } },
        { path: 'aday-at-ashram', component: AboutComponent, data: { section: 'AdayAtAshram' } },
        { path: 'things-to-carry', component: AboutComponent, data: { section: 'ThingstoCarry' } },
        { path: 'rules', component: AboutComponent, data: { section: 'Rules' } },
        { path: 'location', component: AboutComponent, data: { section: 'Location' } },
        { path: 'nature-cure', component: AboutComponent, data: { section: 'NatureCure' } },
        { path: 'testimonials', component: AboutComponent, data: { section: 'Testimonials' } },
        { path: 'workshops', component: AboutComponent, data: { section: 'Workshops' } },
      ]
    },
    {
      path: 'therapies',
      component: TherapiesComponent,
      children: [
        { path: 'treatmentphilosopy', component: TherapiesComponent, data: { section: 'TreatmentPhilosopy' } },
        { path: 'treatments', component: TherapiesComponent, data: { section: 'Treatments' } },
        { path: 'conditionsnottreatedoradmitted', component: TherapiesComponent, data: { section: 'Conditionsnottreatedoradmitted' } },
      ]
    },
    {
      path: 'facilities',
      component: FacilitiesComponent,
      children: [
        { path: 'isfacilitie', component: FacilitiesComponent, data: { section: 'IsFacilitie' } },
        { path: 'isservices', component: FacilitiesComponent, data: { section: 'IsServices' } },
        { path: 'isonlineyoga', component: FacilitiesComponent, data: { section: 'IsOnlineyoga' } },
      ]
    },
    {
      path: 'tariff',
      component: TariffComponent,
      children: [
        { path: 'tariff', component: FacilitiesComponent, data: { section: 'Tariff' } },
        { path: 'cancelationpolicy', component: FacilitiesComponent, data: { section: 'CancelationPolicy' } },
      ]
    },
    {
      path: 'home', pathMatch: 'full',
      component: HomeComponent
    },
    {
      path: 'booking',
      component: BookingComponent,
      children: [
        { path: 'booking', component: BookingComponent, data: { section: 'IsMain' } },
        { path: 'checkavailability', component: BookingComponent, data: { section: 'Checkavailability' } },
      ]
    },
    // {
    //   path: 'contactus', pathMatch: 'full',
    //   component: ContactusComponent
    // },
    {
      path: 'gallery', pathMatch: 'full',
      component: GalleryComponent
    },
    {
      path: 'booking-login', pathMatch: 'full',
      component: BookingLoginComponent
    },
    {
      path: 'booking-login',
      component: BookingLoginComponent,
      children: [
        { path: 'booking-login', component: BookingLoginComponent, data: { section: 'booking-login' } },
        { path: 'booking-login-register', component: BookingLoginComponent, data: { section: 'booking-login-register' } },
        { path: 'UserDetails', component: BookingLoginComponent, data: { section: 'UserDetails' } },
      ]
    },
    {
      path: 'onlineyoga', pathMatch: 'full',
      component: OnlineyogaComponent
    },
    {
      path: 'donate', pathMatch: 'full',
      component: DonateComponent
    },
    {
      path: 'dincharya', pathMatch: 'full',
      component: DincharyaComponent
    },
    { path: 'change-password', component: ChangePasswordComponent, pathMatch: 'full' },
  ]
}];
@NgModule({
  imports: [RouterModule.forChild(SessionRoutes)],
  exports: [RouterModule],
})
export class SessionRoutingModule { }